import { Trash } from 'lucide-react';
import { useMemo, useEffect } from 'react';
import { Button } from '@avanta/shared/components/ui/Button';
import { AudioMessage } from '../../../Message/components';
import { SendButton } from '../SendButton';

interface AudioPreviewProps {
  audioFile: File;
  isSubmitting: boolean;
  onRemove: () => void;
}

export function AudioPreview({
  audioFile,
  isSubmitting,
  onRemove,
}: AudioPreviewProps): React.ReactElement {
  const objectUrl = useMemo(() => URL.createObjectURL(audioFile), [audioFile]);

  useEffect(() => (): void => URL.revokeObjectURL(objectUrl), [objectUrl]);

  return (
    <>
      <AudioMessage
        showName={false}
        file={{
          name: audioFile.name,
          id: audioFile.name,
          url: objectUrl,
          type: audioFile.type,
        }}
      />
      <div className="flex items-center gap-1 justify-end">
        <Button
          variant="ghost"
          type="button"
          onClick={onRemove}
          className="hover:text-red-500 hover:bg-transparent p-0 hover:[&>svg]:stroke-[2.5px] hover:[&>svg]:stroke-red-500"
        >
          <Trash className="size-4.5" />
        </Button>
        <SendButton disabled={isSubmitting} />
      </div>
    </>
  );
}
